import { render } from "./LaravelVuePagination.vue?vue&type=template&id=1d8eca33"
import script from "./LaravelVuePagination.vue?vue&type=script&lang=js"
export * from "./LaravelVuePagination.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__